import React from "react";
import OrderService from '../services/order';
import AuthorizationCheck from '../auth/authorizationCheck';
import DatePiCker from 'react-datepicker';
import Modal from 'react-bootstrap/Modal';
import $ from 'jquery';
import Utility from "../utilities/utility";
import SupplierService from '../services/supplier';
import NumberFormat from "react-number-format";

class SupplierOrders extends React.Component {

    constructor(props) {
        super(props);

        const queryParams = new URLSearchParams(window.location.search);



        this.state = {
            currentUserRole: '',
            orders: [],
            products: [],
            fromDate: '',
            toDate: '',
            suppliers: [],
            newOrderForm: false,
            showOrderProducts: false,
            removeProductConfirmation: false,
            productToRemoveId: null
        }
    }


    componentDidMount() {

        this.supplierOrderList();
        this.suppliers();
    }

    handleCloseProductsModal = () => {

        this.setState({ showOrderProducts: false });
    }

    handleShowProductsModal = (e, orderId) => {

        e.preventDefault();

        localStorage.setItem('selectedSupplierOrder', orderId);

        this.setState({ showOrderProducts: true });

        this.findOrderProducts();
    }

    suppliers = async () => {

        const response = await SupplierService.supplierList();

        if (response.ok) {

            this.setState({
                suppliers: await response.json()
            });
        }
    }

    createOrder = async (e) => {

        e.preventDefault();

        try {

            let description = $('#description').val();

            let supplierId = $('#createSupplierId').val();

            if (Utility.isEmpty(description)) {

                Utility.showAlert('messageHolder', 'Entrez la description', 'danger', true);

                return;
            }

            const response = await OrderService.createSupplierOrder(supplierId, description);

            const order = await response.json();



            if (!Utility.isEmpty(order)) {

                let orders = this.state.orders;

                orders.unshift(order);

                this.setState({

                    orders: orders
                })

                Utility.showAlert('messageHolder', 'Commande crée', 'success', true);

                $('#description').val('');

                return;
            }

            Utility.showAlert('messageHolder', 'Probleme lors de la creation de la commande', 'danger', true);

        } catch (error) {

            Utility.showAlert('messageHolder', 'Probleme lors de la creation de la commande', 'danger', true);
        }


    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }




    supplierOrderList = async () => {

        let description = $('#searchKey').val();
        let supplierId = $('#filterSupplierId').val();
        let fromDate = $('#fromDate').val();
        let toDate = $('#dateTo').val();


        try {
            const response = await OrderService.supplierOrders(supplierId, description, fromDate, toDate);




            if (response.status === 200) {

                let orders = await response.json();




                this.setState(
                    {
                        orders: orders
                    }
                );

                return;

            }

            this.setState(
                {
                    orders: []
                }
            );



        } catch (error) {
            console.log(error)
        }



    }

    setFromDate = (date) => {

        this.setState({ fromDate: date })
    }

    setToDate = (date) => {

        this.setState({ toDate: date })
    }

    resetDate = () => {

        this.setFromDate('');
        this.setToDate('');
    }

    hideNewOrderForm = () => {

        this.setState({

            newOrderForm: false
        })
    }

    showNewOrderForm = (e) => {

        e.preventDefault();
        this.setState({

            newOrderForm: true
        })
    }

    selectOrder(orderId, e) {

        e.preventDefault();

        localStorage.setItem('selectedSupplierOrder', orderId);



        window.location.href = '/manager/supplier/order/product/list';

    }

    findOrderProducts = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let size = $('#size').val();

        const orderId = localStorage.getItem('selectedSupplierOrder');

        if (Utility.isEmpty(orderId)) {

            return;
        }

        try {

            const response = await OrderService.supplierOrderProducts(orderId, name, model, brand, size);
            let products = [];
            if (response.ok) {

                products = await response.json();
            }

            if (Utility.isEmpty()) {

                $('.product-alert-message').html("Pas de produits")
            }

            this.setState({ products: products });
        } catch (error) {

            console.log(error);
        }
    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findOrderProducts();
        }, 1500);

        this.setState({ timeoutId: timer })
    }


    updateOrderProduct = async (productId, e) => {

        e.preventDefault();

        let quantity = $('#product-update-qty-' + productId).val();
        let price = $('#product-update-price-' + productId).val();

        let holder = 'product-row-' + productId;

        if ((quantity < 0 || price < 0) || (Utility.isEmpty(quantity) && Utility.isEmpty(price))) {

            Utility.showAlertWithId(holder, 'Verifiez les données', 'info', true);

            return;
        }

        try {

            const response = await OrderService.updateSupplierOrderProduct(productId, quantity, price);

            if (!response.ok) {

                return;
            }


            if (!Utility.isEmpty(quantity)) {


                $('#product-update-qty-' + productId).val('')

                $('#quantity-holder-' + productId).html(quantity);

            }

            if (!Utility.isEmpty(price)) {


                $('#product-update-price-' + productId).val('');
                $('#price-holder-' + productId).html(price);

            }



        } catch (error) {

            console.log(error);
        }
    }

    hideRemoveProductForm = () => {

        this.setState({ removeProductConfirmation: false });
    }

    confirmProductRemoval = (productId, e) => {

        e.preventDefault();

        this.setState({
            removeProductConfirmation: true,
            productToRemoveId: productId
        });
    }

    removeProduct = async () => {

        const productId = this.state.productToRemoveId;

        if (Utility.isEmpty(productId)) {

            Utility.showAlertWithId('cfbox-message-holder', 'Ressayer', 'danger', true);

            return;
        }

        try {

            const response = await OrderService.removeSupplierOrderProduct(productId);

            let oldProductList = this.state.products;

            if (response.ok) {

                let products = oldProductList.filter((p) => p.id != productId);

                this.setState({
                    products: products,
                    removeProductConfirmation: false
                });

                return;

            }

            Utility.showAlertWithId('cfbox-message-holder', 'Operation non aboutie', 'danger', true);

        } catch (error) {

            Utility.showAlertWithId('cfbox-message-holder', 'Operation non aboutie', 'danger', true);
        }




    }

    updateOrderDescription = async (orderId, e) => {

        e.preventDefault();

        let description = $('#order-desc-' + orderId).val();

        let holder = "order-row-" + orderId;

        let message = "Operation non aboutie";
        let type = "danger";

        try {

            const response = await OrderService.updateSupplierOrderDescription(orderId, description);



            if (response.ok) {

                message = 'Description mis a jour';

                type = 'success';
            }



        } catch (error) {
            console.log(error);
        }

        Utility.showAlertWithId(holder, message, type, true);

    }

    exportOrderProductToExceL = async (orderId, e) => {

        e.preventDefault();

        if (Utility.isEmpty(orderId)) {

            return;
        }

        try {

            const response = await OrderService.supplierOrderProducts(orderId);
            let products = [];
            if (response.ok) {

                products = await response.json();
            }

            if (Utility.isEmpty(products)) {

                $('.product-alert-message').html("Pas de produits");

                return;
            }



            const columns =  [

                    { label: "Nom", value: "name" }, // Top level data
                    { label: "Modele", value: "model" }, // Custom format
                    { label: "Marque", value: "brand" },
                    { label: "Numero", value: "size" },
                    { label: "Couleur", value: "color" },
                    { label: "CPID", value: "supplierUniqueId" },
                    { label: "Prix", value: "price" },
                    
                    { label: "CBM", value: "cbm" },
                    { label: "Poids", value: "weight" },
                    { label: "Quantité Par Carton", value: "quantityInBox" },
                    
                ];

        Utility.exportJsonToExcel("Produits Commande Fournisseurs", columns, products);
        } catch (error) {

            console.log(error);
        }




    }

    render() {

        const rightBtn = {
            width: 200,
            marginLeft: '80%'
        }

        const orders = this.state.orders;
        const suppliers = this.state.suppliers;

        const products = this.state.products;

        let rowNumber = 0;
        let printRowNumber = 0;

        const formInput = {

            width: 150
        }

        return (
            <div className="container orders-wrapper">

                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />

                <h2>Fournisseur Commandes</h2>

                <button className="btn btn-primary" style={rightBtn} onClick={(e) => this.showNewOrderForm(e)}>Nouvelle Commande</button>


                <div className="form-wrapper">

                    <div className="form-group mt-2">

                        <label className="label">Choisi le Fournisseur</label>

                        <select className="form-control" id={"filterSupplierId"} onChange={this.supplierOrderList} >
                            <option></option>
                            {!Utility.isEmpty(suppliers) && suppliers.length > 0 && suppliers.map(supplier =>
                                <option key={supplier.supplierId} value={supplier.supplierId}>{supplier.name}</option>
                            )}
                        </select>

                    </div>


                    <div className="row">
                        <div className="col-md-12">


                            <div className="form-group">
                                <input className="form-control" onFocus={this.resetDate} id="searchKey" placeholder="Description" />
                            </div>
                        </div>

                    </div>
                    <div className="row">

                        <div className="col">
                            <div className="form-group">
                                <DatePiCker id="fromDate" dateFormat="yyyy-MM-dd" selected={this.state.fromDate} placeholderText="De" className="form-control" onChange={this.setFromDate} />
                            </div>
                        </div>
                        <div className="col">

                            <div className="form-group">
                                <DatePiCker id="dateTo" dateFormat="yyyy-MM-dd" selected={this.state.toDate} placeholderText="Jusqua" className="form-control" onChange={this.setToDate} />
                            </div>
                        </div>

                    </div>



                    <div className="form-group">
                        <button className="btn btn-primary" onClick={this.supplierOrderList}>Rechercher</button>
                    </div>


                </div>


                <Modal show={this.state.newOrderForm}>
                    <Modal.Header closeButton onHide={this.hideNewOrderForm}>Nouvelle Commande</Modal.Header>
                    <Modal.Body>



                        <div className="form-wrapper mt-4">

                            <div className="messageHolder"></div>

                            <div className="form-group mt-2">

                                <label className="label">Choisi le Fournisseur</label>

                                <select className="form-control" id={"createSupplierId"} >
                                    <option></option>
                                    {!Utility.isEmpty(suppliers) && suppliers.length > 0 && suppliers.map(supplier =>
                                        <option key={supplier.supplierId} value={supplier.supplierId}>{supplier.name}</option>
                                    )}
                                </select>

                            </div>


                            <div className="form-group">
                                <input className="form-control" id="description" placeholder="Description" />
                            </div>

                            <div className="form-group">
                                <button className="btn btn-primary full-width" onClick={this.createOrder}>Creer</button>
                            </div>


                        </div>



                    </Modal.Body>

                </Modal>


                <Modal show={this.state.removeProductConfirmation} >
                    <Modal.Header closeButton onHide={this.hideRemoveProductForm} className="bg-info text-center">Confirme Suppression</Modal.Header>
                    <Modal.Body className="bg-info">



                        <div className="form-wrapper mt-4">

                            <div id="cfbox-message-holder"></div>


                            <p className="text-center">Voulez vous supprimer ce produit?</p>

                            <button className="btn btn-danger full-width" onClick={this.removeProduct}>Supprimer</button>



                        </div>



                    </Modal.Body>

                </Modal>





                <Modal show={this.state.showOrderProducts} fullscreen={true}>
                    <Modal.Header closeButton onHide={this.handleCloseProductsModal}> Produits</Modal.Header>
                    <Modal.Body>


                        <span className="error-message"></span>

                        <div className='container'>
                            <div className='row'>

                                <div className='col'>Total: <NumberFormat
                                    defaultValue={0}
                                    value={0}
                                    thousandSeparator={true}
                                    displayType="text" decimalScale={2} />
                                </div>

                                <div className='col'>


                                </div>

                            </div>

                            <div className='row mt-2'>


                                <div className="form-wrapper">
                                    <span id="product-list-message-holder"></span>
                                    <div className="row">
                                        <div className="col">


                                            <div className="form-group">
                                                <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="form-group">
                                                <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">

                                            <div className="form-group">
                                                <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="form-group">
                                                <input className="form-control" id="size" placeholder="Numero ou CPID" onKeyUp={this.searchProduct} />
                                            </div>
                                        </div>
                                    </div>






                                </div>

                            </div>

                        </div>

                        {Utility.isEmpty(products) ? <div className="alert alert-info text-center mt-2 product-alert-message">Veillez patienter un peu</div> : ''}

                        {!Utility.isEmpty(products) && products.length > 0 && products.map(product => {


                            rowNumber += 1

                            return <div className="card card-default mt-2 bg-light-gray" key={product.id}>

                                <div className="card-body">
                                    <span className="badge bg-warning">{rowNumber}</span>
                                    <div className="row" id={'product-row-' + product.id}>
                                        <div className="col-md-4">

                                            <div className=''>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                            <div>CPID: {product.supplierUniqueId}</div>

                                        </div>

                                        <div className="col">


                                            <div className="form-group input-max-width text-center">

                                                <div id={"quantity-holder-" + product.id}>{product.quantity}</div>

                                                <input className="form-control " id={"product-update-qty-" + product.id} placeholder="Quantité"
                                                    onBlur={(e) => this.updateOrderProduct(product.id, e)} />



                                            </div>


                                        </div>
                                        <div className="col">

                                            <div className="form-group input-max-width text-center">

                                                <label>Prix</label>
                                                <div id={"price-holder-" + product.id}></div>
                                                <input className="form-control input-max-width" id={"product-update-price-" + product.id} placeholder="Prix"
                                                    defaultValue={product.price} onBlur={(e) => this.updateOrderProduct(product.id, e)} />

                                            </div>



                                        </div>

                                        <div className="col"><button className="btn btn-danger" onClick={(e) => this.confirmProductRemoval(product.id, e)}>X</button></div>



                                    </div>


                                </div>

                            </div>
                        })}

                    </Modal.Body>
                    <Modal.Footer>




                    </Modal.Footer>
                </Modal>


                <div className="orders-wrapper mt-3">

                    {orders != null && orders.length > 0 && orders.map(order =>

                        <div className="card mt-2" key={order.orderId}>
                            <div className="card-body" id={"order-row-" + order.orderId}>

                                <div className="row pb-2">
                                    <div className="col">{order.createdDate}</div>
                                    <div className="col">
                                        <div className="form-group">
                                            <input className="form-control" id={"order-desc-" + order.orderId} defaultValue={order.description}
                                                placeholder="Description" onBlur={(e) => this.updateOrderDescription(order.orderId, e)} />
                                        </div>

                                    </div>
                                    <div className="col">
                                        <div><button className="btn btn-primary full-width" onClick={(e) => this.handleShowProductsModal(e, order.orderId)}>Liste de Produits</button></div>
                                        <div className="mt-2"><button className="btn btn-primary full-width" onClick={(e) => this.selectOrder(order.orderId, e)}>Ajoute produits</button></div>
                                        <div className="mt-2"><button className="btn btn-primary full-width" onClick={(e) => this.exportOrderProductToExceL(order.orderId, e)}>Exporter</button></div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    )}

                </div>
            </div>
        );
    }

}

export default SupplierOrders;